const fuseCategories = [
  // Universal
  { term: "Pet Food", url: "/collections/pet-food" },
  { term: "Food", url: "/collections/pet-food" },
  { term: "Pill Givers", url: "/collections/pill-givers" },
  { term: "Prescription Food", url: "/collections/prescription-food" },
  { term: "Pet First Aid & Recovery", url: "/collections/pet-first-aid-recovery" },
  { term: "Pet First Aid", url: "/collections/pet-first-aid-recovery" },
  { term: "Pet Recovery", url: "/collections/pet-first-aid-recovery" },
  { term: "First Aid & Recovery", url: "/collections/pet-first-aid-recovery" },
  { term: "First Aid", url: "/collections/pet-first-aid-recovery" },
  { term: "Recovery", url: "/collections/pet-first-aid-recovery" },
  { term: "Pet Shampoo & Conditioners", url: "/collections/pet-shampoo-conditioner" },
  { term: "Pet Shampoo", url: "/collections/pet-shampoo-conditioner" },
  { term: "Pet Conditioners", url: "/collections/pet-shampoo-conditioner" },
  { term: "Shampoo & Conditioners", url: "/collections/pet-shampoo-conditioner" },
  { term: "Shampoo", url: "/collections/pet-shampoo-conditioner" },
  { term: "Conditioners", url: "/collections/pet-shampoo-conditioner" },
  { term: "Pet Vitamins & Supplements", url: "/collections/pet-vitamins-supplements" },
  { term: "Pet Vitamins", url: "/collections/pet-vitamins-supplements" },
  { term: "Pet Supplements", url: "/collections/pet-vitamins-supplements" },
  { term: "Vitamins & Supplements", url: "/collections/pet-vitamins-supplements" },
  { term: "Vitamins", url: "/collections/pet-vitamins-supplements" },
  { term: "Supplements", url: "/collections/pet-vitamins-supplements" },
  { term: "Pet Apparel", url: "/collections/pet-apparel" },
  { term: "Pet Clothing", url: "/collections/pet-apparel" },
  { term: "Pet Outfits", url: "/collections/pet-apparel" },
  { term: "Apparel", url: "/collections/pet-apparel" },
  { term: "Clothing", url: "/collections/pet-apparel" },
  { term: "Outfits", url: "/collections/pet-apparel" },
  { term: "Pet Treats", url: "/collections/pet-treats" },
  { term: "Treats", url: "/collections/pet-treats" },
  { term: "Pet Toys", url: "/collections/pet-toys" },
  { term: "Toys", url: "/collections/pet-toys" },
  { term: "Pet Healthcare", url: "/collections/pet-healthcare" },
  { term: "Healthcare", url: "/collections/pet-healthcare" },
  { term: "Pet Accessories", url: "/collections/pet-accessories" },
  { term: "Accessories", url: "/collections/pet-accessories" },
  { term: "Pet Conditions", url: "/collections/pet-conditions" },
  { term: "Conditions", url: "/collections/pet-conditions" },

  
  { term: "Offers", url: "/collections/sale" },
  { term: "Deals", url: "/collections/sale" },
  { term: "Repeat & Save", url: "/collections/repeat-save" },
  { term: "Repeat", url: "/collections/repeat-save" },
  { term: "Subscription", url: "/collections/repeat-save" },
  { term: "Vet's Favourite", url: "/collections/vets-favourite" },
  { term: "Veterinary Favourite", url: "/collections/vets-favourite" },
  { term: "Vet Approved", url: "/collections/vets-favourite" },
  { term: "Veterinary Approved", url: "/collections/vets-favourite" },

  
  { term: "Dog", url: "/collections/dog" },
  { term: "Cat", url: "/collections/cats" },


  // Dog Food
  { term: "Dog Food", url: "/collections/dog-food" },
  { term: "Dry Dog Food", url: "/collections/dry-dog-food" },
  { term: "Wet Dog Food", url: "/collections/wet-dog-food" },
  { term: "Prescription Dog Food", url: "/collections/prescription-dog-food" },
  { term: "Dog Treats", url: "/collections/dog-treats" },
  { term: "Hypoallergenic Dog Food", url: "/collections/hypoallergenic-dog-food" },
  { term: "Grain-Free Dog Food", url: "/collections/grain-free-dog-food" },
  { term: "Senior Dog Food", url: "/collections/senior-dog-food" },
  //
  // Dog Healthcare
  { term: "Dog Healthcare", url: "/collections/dog-healthcare" },
  { term: "Dog Vitamins & Supplements", url: "/collections/dogs-vitamin-supplements" },
  { term: "Dog Vitamins", url: "/collections/dogs-vitamin-supplements" },
  { term: "Dog Supplements", url: "/collections/dogs-vitamin-supplements" },
  { term: "Dog Prescriptions", url: "/collections/dog-prescriptions" },
  { term: "Dog Flea & Tick", url: "/collections/dog-flea-and-tick-control" },
  { term: "Dog Wormer", url: "/collections/dog-flea-and-tick-control" },
  { term: "Dog Dental Care", url: "/collections/dog-dental-care" },
  { term: "Dog Shampoo & Conditioners", url: "/collections/dog-shampoo-conditioners" },
  { term: "Dog Shampoo", url: "/collections/dog-shampoo-conditioners" },
  { term: "Dog Conditioners", url: "/collections/dog-shampoo-conditioners" },
  { term: "Dog First Aid", url: "/collections/dogs-first-aid" },
  { term: "Dog Recovery", url: "/collections/dogs-first-aid" },
  { term: "Dog Hairball", url: "/collections/dogs-hairball-laxative-remedies" },
  { term: "Dog Laxative", url: "/collections/dogs-hairball-laxative-remedies" },
  //
  // Dog Accessories
  { term: "Dog Accessories", url: "/collections/dog-accessories" },
  { term: "Dog Bowls", url: "/collections/dog-bowls-feeders-and-waterers" },
  { term: "Dog Feeders", url: "/collections/dog-bowls-feeders-and-waterers" },
  { term: "Dog Combs & Brushes", url: "/collections/combs-brushes" },
  { term: "Dog Combs", url: "/collections/combs-brushes" },
  { term: "Dog Brushes", url: "/collections/combs-brushes" },
  { term: "Dog Collars & Leads", url: "/collections/dog-collars-leads" },
  { term: "Dog Collars", url: "/collections/dog-collars-leads" },
  { term: "Dog Leads", url: "/collections/dog-collars-leads" },
  { term: "Dog Toys", url: "/collections/dog-toys" },
  { term: "Dog Beds", url: "/collections/dog-beds" },
  { term: "Dog Odour & Stain", url: "/collections/dog-odour-stain-remover" },
  { term: "Dog Odour & Stain Remover", url: "/collections/dog-odour-stain-remover" },
  { term: "Dog Stain Remover", url: "/collections/dog-odour-stain-remover" },
  { term: "Dog Deterrent", url: "/collections/dog-deterrent-repellents" },
  { term: "Dog Repellents", url: "/collections/dog-deterrent-repellents" },
  { term: "Dog Apparel", url: "/collections/dog-apparel" },
  { term: "Dog Clothing", url: "/collections/dog-apparel" },
  { term: "Dog Outfits", url: "/collections/dog-apparel" },
  //
  // Dog Conditions
  { term: "Dog Conditions", url: "/collections/dog-conditions" },
  { term: "Dog Allergy & Skin", url: "/collections/dog-allergy-skin-care" },
  { term: "Dog Allergy", url: "/collections/dog-allergy-skin-care" },
  { term: "Dog Anxiety & Calmers", url: "/collections/dog-anxiety-calmers" },
  { term: "Dog Anxiety", url: "/collections/dog-anxiety-calmers" },
  { term: "Dog Calmers", url: "/collections/dog-anxiety-calmers" },
  { term: "Diabetic Dog", url: "/collections/diabetic-dog-care" },
  { term: "Dog Digestive", url: "/collections/digestive-care-for-dogs" },
  { term: "Dog Ear Health", url: "/collections/ear-health-products-for-dogs" },
  { term: "Dog Ear", url: "/collections/ear-health-products-for-dogs" },
  { term: "Dog Eye Health", url: "/collections/eye-health-products-for-dogs" },
  { term: "Dog Eye", url: "/collections/eye-health-products-for-dogs" },
  { term: "Dog Joint Care", url: "/collections/joint-mobility-for-dogs" },
  { term: "Dog Joint", url: "/collections/joint-mobility-for-dogs" },
  { term: "Dog Mobility", url: "/collections/joint-mobility-for-dogs" },
  { term: "Dog Joint & Mobility", url: "/collections/joint-mobility-for-dogs" },
  { term: "Dog Liver Health", url: "/collections/liver-health-products-for-dogs" },
  { term: "Dog Liver Care", url: "/collections/liver-health-products-for-dogs" },
  { term: "Dog Liver", url: "/collections/liver-health-products-for-dogs" },
  { term: "Dog Kidney Health", url: "/collections/kidney-health-products-for-dogs" },
  { term: "Dog Kidney Care", url: "/collections/kidney-health-products-for-dogs" },
  { term: "Dog Urinary & Bladder", url: "/collections/dogs-urinary-bladderdogs-urinary-bladder" },
  { term: "Dog Bladder", url: "/collections/dogs-urinary-bladderdogs-urinary-bladder" },
  //
  // Puppy
  { term: "Puppy", url: "/collections/puppy-products" },
  { term: "Puppy Food", url: "/collections/puppy-food" },
  { term: "Wet Puppy Food", url: "/collections/wet-puppy-food" },
  { term: "Dry Puppy Food", url: "/collections/dry-puppy-food" },
  { term: "Puppy Toys", url: "/collections/puppy-toys" },
  { term: "Puppy Grooming", url: "/collections/puppy-grooming-supplies" },

  // Cat Food
  { term: "Cat Food", url: "/collections/cat-food" },
  { term: "Dry Cat Food", url: "/collections/dry-cat-food" },
  { term: "Wet Cat Food", url: "/collections/wet-cat-food" },
  { term: "Prescription Cat Food", url: "/collections/prescription-cat-food" },
  { term: "Cat Treats", url: "/collections/cat-treats" },
  { term: "Hypoallergenic Cat Food", url: "/collections/hypoallergenic-cat-food" },
  { term: "Grain-Free Cat Food", url: "/collections/grain-free-cat-food" },
  { term: "Senior Cat Food", url: "/collections/senior-cat-food" },
  //
  // Cat Healthcare
  { term: "Cat Healthcare", url: "/collections/cat-healthcare" },
  { term: "Cat Vitamins & Supplements", url: "/collections/cats-vitamin-supplements" },
  { term: "Cat Vitamins", url: "/collections/cats-vitamin-supplements" },
  { term: "Cat Supplements", url: "/collections/cats-vitamin-supplements" },
  { term: "Cat Prescriptions", url: "/collections/cat-prescriptions" },
  { term: "Cat Flea & Tick", url: "/collections/cat-flea-and-tick-control" },
  { term: "Cat Wormer", url: "/collections/cat-flea-and-tick-control" },
  { term: "Cat Dental Care", url: "/collections/cat-dental-care" },
  { term: "Cat Shampoo & Conditioners", url: "/collections/cat-shampoo-conditioners" },
  { term: "Cat Shampoo", url: "/collections/cat-shampoo-conditioners" },
  { term: "Cat Conditioners", url: "/collections/cat-shampoo-conditioners" },
  { term: "Cat First Aid", url: "/collections/cats-first-aid" },
  { term: "Cat Recovery", url: "/collections/cats-first-aid" },
  { term: "Cat Hairball", url: "/collections/cats-hairball-laxative-remedies" },
  { term: "Cat Laxative", url: "/collections/cats-hairball-laxative-remedies" },
  //
  // Cat Accessories
  { term: "Cat Accessories", url: "/collections/cat-accessories" },
  { term: "Cat Litter", url: "/collections/cat-litter" },
  { term: "Cat Toys", url: "/collections/cat-toys" },
  { term: "Catnip", url: "/collections/catnip" },
  { term: "Cat Combs & Brushes", url: "/collections/combs-brushes" },
  { term: "Cat Combs", url: "/collections/combs-brushes" },
  { term: "Cat Brushes", url: "/collections/combs-brushes" },
  { term: "Cat Bowls", url: "/collections/cat-bowls" },
  { term: "Cat Feeders", url: "/collections/cat-bowls" },
  { term: "Cat Beds & Furniture", url: "/collections/cat-beds-furniture" },
  { term: "Cat Beds", url: "/collections/cat-beds-furniture" },
  { term: "Cat Furniture", url: "/collections/cat-beds-furniture" },
  { term: "Cat Collars & Harnesses", url: "/collections/cat-collars-and-harnesses" },
  { term: "Cat Collars", url: "/collections/cat-collars-and-harnesses" },
  { term: "Cat Harnesses", url: "/collections/cat-collars-and-harnesses" },
  { term: "Cat Carriers & Crates", url: "/collections/cat-carriers-and-crates" },
  { term: "Cat Carriers", url: "/collections/cat-carriers-and-crates" },
  { term: "Cat Crates", url: "/collections/cat-carriers-and-crates" },
  { term: "Cat Odour & Stain Remover", url: "/collections/cat-odour-stain-remover" },
  { term: "Cat Odour", url: "/collections/cat-odour-stain-remover" },
  { term: "Cat Stain Remover", url: "/collections/cat-odour-stain-remover" },
  { term: "Cat Deterrent & Repellents", url: "/collections/cat-deterrent-repellents" },
  { term: "Cat Deterrent", url: "/collections/cat-deterrent-repellents" },
  { term: "Cat Repellents", url: "/collections/cat-deterrent-repellents" },
  { term: "Cat Apparel", url: "/collections/cat-apparel" },
  { term: "Cat Clothing", url: "/collections/cat-apparel" },
  { term: "Cat Outfits", url: "/collections/cat-apparel" },
  //
  // Cat Conditions
  { term: "Cat Conditions", url: "/collections/cat-conditions" },
  { term: "Cat Allergy & Skin", url: "/collections/cat-allergy-skin-care" },
  { term: "Cat Allergy", url: "/collections/cat-allergy-skin-care" },
  { term: "Cat Anxiety & Calmers", url: "/collections/cat-anxiety-calmers" },
  { term: "Cat Anxiety", url: "/collections/cat-anxiety-calmers" },
  { term: "Cat Calmers", url: "/collections/cat-anxiety-calmers" },
  { term: "Diabetic Cat", url: "/collections/diabetic-cat-care" },
  { term: "Digestive Cat", url: "/collections/digestive-care-for-cats" },
  { term: "Cat Ear", url: "/collections/ear-health-products-for-cats" },
  { term: "Cat Eye", url: "/collections/eye-health-products-for-cats" },
  { term: "Cat Joint & Mobility", url: "/collections/joint-mobility-for-cats" },
  { term: "Cat Joint", url: "/collections/joint-mobility-for-cats" },
  { term: "Cat Mobility", url: "/collections/joint-mobility-for-cats" },
  { term: "Cat Liver", url: "/collections/liver-health-products-for-cats" },
  { term: "Cat Kidney", url: "/collections/kidney-health-products-for-cats" },
  { term: "Cat Urinary", url: "/collections/cats-urinary-bladder" },
  { term: "Cat Bladder", url: "/collections/cats-urinary-bladder" },
  //
  // Kitten
  { term: "Kitten", url: "/collections/kitten-products" },
  { term: "Kitten Food", url: "/collections/kitten-food" },
  { term: "Wet Kitten Food", url: "/collections/wet-kitten-food" },
  { term: "Dry Kitten Food", url: "/collections/dry-kitten-food" },
  { term: "Kitten Toys", url: "/collections/kitten-toys" },
  { term: "Kitten Treats", url: "/collections/kitten-treats" },
  { term: "Kitten Grooming", url: "/collections/kitten-grooming-supplies" },

  // Brands
  { term: "Hill's", url: "/collections/hills" },
  { term: "Ceva", url: "/collections/ceva" },
  { term: "Protexin", url: "/collections/protexin" },
  { term: "Trixie", url: "/collections/trixie" },
  { term: "Kong", url: "/collections/kong" },
  { term: "Lintbells", url: "/collections/lintbells" },
  { term: "YuMOVE", url: "/collections/lintbells" },
  { term: "Purina", url: "/collections/purina" },
  { term: "Pro Plan", url: "/collections/purina" },
  { term: "Virbac", url: "/collections/virbac" },
  { term: "Vetoquinol", url: "/collections/vetoquinol" },
  { term: "Royal Canin", url: "/collections/royal-canin" },
  
  // Prescription
  { term: "Pain Relief", url: "/collections/prescriptions?filter.p.product_type=Pain+%26+Anti-inflammatory" },
  { term: "Anti-inflammatory", url: "/collections/prescriptions?filter.p.product_type=Pain+%26+Anti-inflammatory" },
  { term: "Hormonal", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
  { term: "Hormone", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
  { term: "Hormone Medicine", url: "/collections/prescriptions?filter.p.product_type=Hormonal+Support" },
  { term: "Allergy Treatments", url: "/collections/prescriptions?filter.p.product_type=Allergy+Treatments" },
  { term: "Allergy Medicine", url: "/collections/prescriptions?filter.p.product_type=Allergy+Treatments" },
  { term: "Prescriptions", url: "/collections/prescriptions" }
];

const fuseFilterOmit = [
  "pet",
  "pets",
  "product",
  "products",
  "care",
  "supplies",
  "support",
  "control",
  "health"
];

const fuseWords = [
  "A-Ball",
  "A-Partz",
  "AKTIVAIT",
  "APRYLIC",
  "ATOP",
  "Acana",
  "Aceponate",
  "Action",
  "Active",
  "Activity",
  "Adaptil",
  "Add",
  "Added",
  "Additional",
  "Additive",
  "Adenovirus",
  "Adhesive",
  "Adt",
  "Adult",
  "Adults",
  "Advance",
  "Advanced",
  "Advantage",
  "Ageing",
  "Agility",
  "Aid",
  "Aids",
  "AirDog",
  "All",
  "Allerderm",
  "Allermyl",
  "Alligator",
  "American",
  "Amodip",
  "Anal",
  "Ancient",
  "Ancol",
  "And",
  "Animal",
  "Animals",
  "Anti",
  "Antiseptic",
  "Anxiety",
  "Anxitane",
  "Apoquel",
  "Apple",
  "Aqua",
  "Aquadent",
  "Asbrip",
  "Aspergillus",
  "Assorted",
  "Atopica",
  "AvoCATo",
  "Away",
  "BUNDLE",
  "BUSTER",
  "Babycat",
  "Babydog",
  "Backseat",
  "Bag",
  "Bags",
  "Bake",
  "Balance",
  "Ball",
  "Ballistic",
  "Balloon",
  "Balls",
  "Balm",
  "Bamboo",
  "Bandage",
  "Barnyard",
  "Barrier",
  "Bars",
  "Based",
  "Basic",
  "Baskerville",
  "Basket",
  "Bat",
  "Bayer",
  "Bear",
  "Beaver",
  "Beco",
  "Bed",
  "Bedding",
  "Bedtime",
  "Bee",
  "Beef",
  "Belly",
  "Belt",
  "Bench",
  "Benefit",
  "Berlin",
  "Best",
  "Better",
  "Big",
  "Binkie",
  "Bio",
  "Biome",
  "Bionic",
  "Biotic",
  "Biotin",
  "Bird",
  "Birds",
  "Birthday",
  "Biscuit",
  "Biscuits",
  "Bisolvon",
  "Bites",
  "Bitter",
  "Black",
  "Blade",
  "Blood",
  "Blue",
  "Blue/Beige",
  "Blueberry",
  "Boa",
  "Boar",
  "Board",
  "Bobz",
  "Body",
  "Bone",
  "Bones",
  "Boost",
  "Booster",
  "Boot",
  "Boots",
  "Bottle",
  "Bountiful",
  "Bounzer",
  "Bowl",
  "Bowls",
  "Box",
  "Boy",
  "Brain",
  "Brands",
  "Breaker",
  "Breakfast",
  "Breaktime",
  "Breed",
  "Brights",
  "Bristle",
  "Broccoli",
  "Broth",
  "Brown",
  "Brush",
  "Bugalugs",
  "Bundle",
  "Bungalow",
  "Bunji",
  "Bunny",
  "Burgers",
  "Burrito",
  "Buster",
  "Butter",
  "ButterSquash",
  "Butterfly",
  "Butternut",
  "Buzz",
  "Buzzy",
  "CANIN",
  "CATBana",
  "CET",
  "CLX",
  "CONTINENCE",
  "Cactus",
  "Calibrated",
  "Calicivirus",
  "Calm",
  "Calming",
  "Calorie",
  "Campfire",
  "Campylobacter",
  "Can",
  "Canidryl",
  "Canine",
  "Caninsulin",
  "Caniphedrin",
  "Canned",
  "Cans",
  "Capsules",
  "CarSafe",
  "Card",
  "Care",
  "Carnival",
  "Carprieve",
  "Carprodyl",
  "Carprox",
  "Carrier",
  "Carrot",
  "Carry",
  "Cartridges",
  "Casper",
  "Casserole",
  "Cat",
  "Catch",
  "Caterpillar",
  "Caticorn",
  "Catit",
  "Catmosphere",
  "Catnip",
  "Catrine",
  "Cats",
  "Catsan",
  "Catwalk",
  "Cerenia",
  "Chameleon",
  "Chappie",
  "Characters",
  "Chateau",
  "Cheese",
  "Cheetah",
  "Chew",
  "ChewStix",
  "Chewable",
  "Chews",
  "Chick",
  "Chicken",
  "Chill",
  "Chillz",
  "Chirpz",
  "Chlamydia",
  "Chomp",
  "Chonks",
  "Cigar",
  "Cimalgex",
  "Ckn",
  "Classic",
  "Classics",
  "Clean",
  "Cleaner",
  "Cleaning",
  "Cleanser",
  "Cleansing",
  "Clear",
  "Clic",
  "Clicker",
  "Clikka",
  "Clinical",
  "Clippers",
  "Clomicalm",
  "Clorexyderm",
  "Clostridial",
  "Cloud",
  "Coa",
  "Coachi",
  "Coarse",
  "Coast",
  "Coat",
  "Coated",
  "Coats",
  "Cobalaplex",
  "Coccidia",
  "Cod",
  "Coli",
  "Collapsible",
  "Collar",
  "Collection",
  "Colours",
  "Comb",
  "Comber",
  "Combi",
  "Comet",
  "Comfort",
  "Compact",
  "Complete",
  "Concentrated",
  "Confetti",
  "Connects",
  "Consult",
  "Control",
  "Cooked",
  "Cooling",
  "Coprostop",
  "CoreStrength",
  "Corestrength",
  "Cork",
  "Corneal",
  "Cortavance",
  "Cortisol",
  "Cottage",
  "Cotton",
  "Cough",
  "Count",
  "Countryside",
  "Cover",
  "Cozie",
  "Crab",
  "Crackerjacks",
  "Cracking",
  "Crackle",
  "Crackles",
  "Cradle",
  "Cranberry",
  "Creatinine",
  "Critter",
  "Cross",
  "Crunch",
  "CrunchAir",
  "Cruncheez",
  "Cryptosporidia",
  "Cube",
  "Cuddler",
  "Cuisine",
  "Culture",
  "Curlz",
  "Cushion",
  "Cutaneous",
  "CuteSeas",
  "Cuts",
  "Cystease",
  "CystoPro",
  "Cystophan",
  "D-C",
  "DIETS",
  "DLH",
  "DOUXO",
  "DSH",
  "Daily",
  "Danish",
  "Dasuquin",
  "Dechra",
  "Defence",
  "Deluxe",
  "Demodex",
  "Denamarin",
  "Dent",
  "Dental",
  "Dentihex",
  "Derm",
  "Dermacomfort",
  "DermalEase",
  "Dermanolon",
  "Dermatophyte",
  "Dermoscent",
  "Design",
  "Dexacortone",
  "Diabetes",
  "Diabetic",
  "Diarrohoea",
  "Diet",
  "Diffuser",
  "Digestion",
  "Digestive",
  "Dinner",
  "Dipstick",
  "Disc",
  "Disinfectant",
  "Dispenser",
  "Dispensing",
  "Disposable",
  "Document",
  "Dog",
  "Dogs",
  "Donkey",
  "Donut",
  "Dorwest",
  "Dotz",
  "Double",
  "Douxo",
  "Dragon",
  "Dreamies",
  "Dried",
  "Droncit",
  "Dronspot",
  "Drontal",
  "Drops",
  "Dry",
  "Dual",
  "Duck",
  "Dumbbell",
  "Dummy",
  "Duo",
  "Duramax",
  "Dynos",
  "ELISA",
  "Ear",
  "Eared",
  "Early",
  "EaseFlex",
  "Easy",
  "EasyPill",
  "Eaze",
  "Educ",
  "Effipro",
  "Egg",
  "Electrophoresis",
  "Elephant",
  "Emeprid",
  "Enchanted",
  "Ended",
  "Endogard",
  "Energy",
  "English",
  "Enterogenic",
  "Entr",
  "Enurace",
  "Enzorb",
  "Enzymatic",
  "Enzyme",
  "Eon",
  "Epi-Otic",
  "Ergo",
  "Ermidra",
  "Essential",
  "Ever",
  "Examination",
  "Exigent",
  "Expert",
  "Extra",
  "Extreme",
  "Eye",
  "F10",
  "F10SC",
  "FELIWAY",
  "FRONTLINE",
  "FRONTPRO",
  "Face",
  "Faeces",
  "Famous",
  "Fat",
  "Favourites",
  "Feast",
  "Feather",
  "Fed",
  "Feeder",
  "Feeding",
  "Felimazole",
  "Feline",
  "Feline/Canine",
  "Feliway",
  "Fetch",
  "FetchStix",
  "Fibre",
  "File",
  "Fillets",
  "Film",
  "Fine",
  "Finger",
  "Finilac",
  "Finz",
  "First",
  "Fish",
  "Fisherman's",
  "Fishy",
  "Fit",
  "Flamingo",
  "Flavour",
  "Flavoured",
  "Flavours",
  "Flea",
  "Flexball",
  "Flingaroo",
  "Flip",
  "Floofs",
  "Floppy",
  "Flops",
  "Flopzie",
  "Fluid",
  "Flutterz",
  "Flyer",
  "Foam",
  "Foetus",
  "Fold",
  "Folding",
  "Food",
  "Football",
  "For",
  "Forthyron",
  "FortiFlora",
  "Fox",
  "Fr3sh",
  "Frazzle",
  "Free",
  "Freeze",
  "Friends",
  "Frizzle",
  "Frog",
  "Front",
  "Fun",
  "Function",
  "Furr",
  "Furry",
  "Galastop",
  "Galliprant",
  "Game",
  "Garden",
  "Gastro",
  "Gastrointestinal",
  "Gatoi",
  "Gecko",
  "Gel",
  "General",
  "Geodz",
  "Germicidal",
  "Giant",
  "Giardia",
  "Gift",
  "Giraffe",
  "Giver",
  "Gland",
  "Glandex",
  "Glorious",
  "Glove",
  "Gnashers",
  "Gold",
  "Goodie",
  "Goomz",
  "Goulash",
  "Grain",
  "Grains",
  "Grannick's",
  "Granules",
  "Grass",
  "Grasslands",
  "Gravity",
  "Gravy",
  "Green",
  "Grey",
  "Groom",
  "Grooming",
  "Gun",
  "Gut",
  "Gyro",
  "H20",
  "H2O",
  "Hair",
  "Hairball",
  "Hairballs/Furballs",
  "Halo",
  "Halti",
  "Hammock",
  "HandiPOD",
  "Handle",
  "Happy",
  "Hard",
  "Harness",
  "Harvest",
  "Headcollar",
  "Health",
  "Healthy",
  "Heat",
  "HedgeHug",
  "Help",
  "Henry",
  "Hepatic",
  "Hepaticare",
  "Heritage",
  "Herpesvirus",
  "Hexarinse",
  "Hibiwash",
  "Hide",
  "Hideaway",
  "High",
  "Highest",
  "Hiking",
  "Hill",
  "Hill's",
  "Hills",
  "Hind",
  "Hole",
  "Home",
  "HomeoPet",
  "Homeopathic",
  "Homestead",
  "Honkers",
  "Horn",
  "Hotpot",
  "Hound",
  "Hula",
  "Hummingbird",
  "Hydra",
  "Hydration",
  "Hydrocortisone",
  "Hygiene",
  "Hygienic",
  "HypoAllergenic",
  "Hypoallergenic",
  "In-One",
  "IncrediBowl",
  "Incurin",
  "Indoor",
  "Indorex",
  "Inflacam",
  "Inflatable",
  "Infused",
  "Infuser",
  "Injection",
  "Injuries",
  "Innovations",
  "Insulated",
  "Insulin",
  "Interactive",
  "Interchangeable",
  "Intestinal",
  "Itching",
  "Jack",
  "James",
  "Jaxx",
  "Jelly",
  "Jerky",
  "Johnson's",
  "Joii",
  "Joint",
  "JointWell",
  "Jolly",
  "Jumbler",
  "Jumbo",
  "Jump",
  "Junior",
  "KONG",
  "Kalm",
  "KarmaWrap",
  "Katalax",
  "Khaki",
  "Kibble",
  "Kickeroo",
  "Kickeroos",
  "Kiddos",
  "Kidney",
  "Kit",
  "Kitchen",
  "Kitten",
  "Kittens",
  "Kitty",
  "Knee",
  "Knife",
  "Knobby",
  "Knot",
  "Knots",
  "Koala",
  "Kolin",
  "Kradle",
  "Krunchies",
  "Kruuse",
  "Kumfy",
  "L-Lysine",
  "LYPEX",
  "Lab",
  "Ladybug",
  "Lamb",
  "Large",
  "Larvae",
  "Laser",
  "Launcher",
  "Laxapet",
  "Laxatract",
  "Lead",
  "Lean",
  "Legs",
  "Legz",
  "Leishmania",
  "Leucillin",
  "Leventa",
  "Librela",
  "Lick'n'",
  "LickiMat",
  "Licks",
  "Life",
  "Light",
  "Lightweight",
  "Lily's",
  "Line",
  "Liquid",
  "Litter",
  "Little",
  "Liver",
  "Llama",
  "Llamas",
  "Loaf",
  "Lock",
  "Logic",
  "Long",
  "Low",
  "Loxicom",
  "Lube",
  "Lubricating",
  "Lubrithal",
  "Lung",
  "Luv",
  "MDC",
  "MPS",
  "Machine",
  "Maintenance",
  "Malaseb",
  "Mallard",
  "Malt",
  "Management",
  "Mango",
  "Marvin",
  "Master",
  "Mat",
  "Matt",
  "Matts",
  "Mature",
  "Max",
  "Maxi",
  "Maxx",
  "Maze",
  "Mealtime",
  "Meat",
  "Meaty",
  "Medical",
  "Medium",
  "Medrone",
  "Mega",
  "Meloxidyl",
  "Memory",
  "Meowee",
  "Metabolic",
  "Metacam",
  "Meticillin",
  "Microscopy",
  "Microwavable",
  "Mighty",
  "Mikki",
  "Milk",
  "Min",
  "Mini",
  "Miniature",
  "Minijacks",
  "Mirataz",
  "Mix",
  "Mixed",
  "Mobile",
  "Mobility",
  "Moderate",
  "Moggy",
  "Moose",
  "Mother",
  "Mothering",
  "Moult",
  "Moulting",
  "Mouse",
  "Mousse",
  "Multi",
  "MultiVits",
  "Multicare",
  "Multipack",
  "Munchies",
  "Mussel",
  "Mutt",
  "Muzzle",
  "Mycoplasma",
  "Nail",
  "Natural",
  "Naturals",
  "Navy",
  "Needles",
  "Neurocare",
  "Neutered",
  "Nextmune",
  "Nibble",
  "Nibbles",
  "Niblets",
  "Nights",
  "Nina",
  "Nippers",
  "Non",
  "Noys",
  "Nursing",
  "Nutri",
  "Nutrition",
  "Nylon",
  "ON-CARE",
  "ON-Care",
  "Occasions",
  "Occult",
  "Ocean",
  "Ocry-Gel",
  "Ocryl",
  "Octopus",
  "Odour",
  "Off",
  "Ogee",
  "Oil",
  "Ointment",
  "Old",
  "On-Care",
  "On-the-Go",
  "One",
  "One-A-Day",
  "One-a-day",
  "Onsior",
  "Onychotin",
  "Ophthalmic",
  "OptiFit",
  "Optimmune",
  "Optimum",
  "Optixcare",
  "Oral",
  "Oralade",
  "Orange",
  "Orbitz",
  "Organic",
  "Original",
  "Orthopaedic",
  "Oto",
  "Otoact",
  "Otoclean",
  "Otodex",
  "Otodine",
  "Otoprof",
  "Ottosson",
  "Out",
  "Outward",
  "Over",
  "Owl",
  "PCR",
  "PDQ",
  "PLAN",
  "PLUS",
  "PRO",
  "PURINA",
  "PYOclean",
  "Pacifica",
  "Pack",
  "Package",
  "Pad",
  "Pads",
  "Panacur",
  "Pancreatic",
  "Panel",
  "Panleucopaenia",
  "Pants",
  "Panzym",
  "Papaya",
  "Parasite",
  "Pardale-V",
  "Party",
  "Parvovirus",
  "Paste",
  "Pastels",
  "Pat",
  "Pate",
  "Paw",
  "Paws",
  "Pea",
  "Peanut",
  "Peas",
  "Peptivet",
  "Perfect",
  "Perfringens",
  "Pet",
  "PetGear",
  "Petface",
  "Petkin",
  "Petlife",
  "Petrol",
  "Pets",
  "Phatz",
  "Pie",
  "Pig",
  "Pill",
  "Pillow",
  "Pin",
  "Ping",
  "Pink",
  "Pippettes",
  "Plan",
  "Plant",
  "Plaque",
  "Plastic",
  "Play",
  "PlaySpaces",
  "Playdate",
  "Plus",
  "Plush",
  "Pocket",
  "Pocketz",
  "Pointer",
  "Pong",
  "Pooch",
  "Poop",
  "Porcupine",
  "Pork",
  "Porus",
  "Post",
  "Potato",
  "Pouches",
  "Poultry",
  "Powder",
  "Power",
  "Powered",
  "Poxvirus",
  "Prairie",
  "Prednicare",
  "Prednicortone",
  "Prednidale",
  "Prednisolone",
  "Premium",
  "Prescription",
  "Previcox",
  "Pro",
  "ProZinc",
  "Probiotic",
  "Products",
  "Professional",
  "Pronefra",
  "Propalin",
  "Protector",
  "Protectorband",
  "Protein",
  "Protexin",
  "Pull",
  "Pumpkin",
  "Pup",
  "Puppies",
  "Puppy",
  "Purple",
  "Purrsuit",
  "Puzzle",
  "Puzzlements",
  "Pyo",
  "Quadri",
  "Quest",
  "Quickfit",
  "RECOVA",
  "ROYAL",
  "Rabbits",
  "Radiator",
  "Rainbow",
  "Rake",
  "Ramp",
  "Ranchlands",
  "Range",
  "Ratio",
  "Razzle",
  "Recipe",
  "Recipes",
  "Reconcile",
  "Recovery",
  "Red",
  "Reducing",
  "Reduction",
  "Reefz",
  "Refill",
  "Refillable",
  "Refillables",
  "Refills",
  "Reflective",
  "Reflex",
  "Rehab",
  "Rehydrating",
  "Relaxed",
  "Remedy",
  "Remend",
  "Removal",
  "Remover",
  "Renal",
  "Replacement",
  "Resistant",
  "Respiratory",
  "Response",
  "Reward",
  "Rewards",
  "Rheumocam",
  "Ribbon",
  "Rice",
  "Rimadyl",
  "Ring",
  "Ringworm",
  "Robexera",
  "Roll",
  "Roller",
  "Rope",
  "Rosewood",
  "Rottweiler",
  "Rubber",
  "Run",
  "Rycarfa",
  "S/O",
  "Sachet",
  "Sachets",
  "Safestix",
  "Safety",
  "Salmon",
  "Salmonella",
  "Satiety",
  "Saucer",
  "Sausages",
  "Savour",
  "Scalibor",
  "Scavenge",
  "Science",
  "Scissors",
  "Scoopz",
  "Scratch",
  "Scratch/Lick/Bite",
  "Scratcher",
  "Scratching",
  "Scrattles",
  "Screen",
  "Scruffs",
  "Scrumbles",
  "Scrumptious",
  "Scrunch",
  "Sea",
  "Seagull",
  "Seat",
  "Seb",
  "Sebo",
  "Second",
  "Sediment",
  "Select",
  "Selection",
  "Self",
  "Selgian",
  "Senior",
  "Senses",
  "Sensitive",
  "Sensitivities",
  "Sensitivity",
  "Sensory",
  "Senvelgo",
  "Seresto",
  "Set",
  "Shakers",
  "Shampoo",
  "Shedding",
  "Sheep",
  "Shell",
  "Shells",
  "Shepherd's",
  "Sherps",
  "Shieldz",
  "Shimmy",
  "Shirt",
  "Shop",
  "Short",
  "Shredded",
  "Shrimps",
  "Sided",
  "Signature",
  "Silicone",
  "Silvervine",
  "Simple",
  "Simply",
  "Single",
  "Singles",
  "Skin",
  "Skunk",
  "Sleeve",
  "Slender",
  "Slicker",
  "Slim",
  "Slip",
  "Sloth",
  "Slow",
  "Small",
  "Smart",
  "Smooth",
  "Snack",
  "Snacks",
  "Sneakerz",
  "Snoozer",
  "Snowy",
  "Snugga",
  "Snuggle",
  "Snugglesafe",
  "Snuzzles",
  "Soccer",
  "Soft",
  "SoftE",
  "SoftSeas",
  "Softening",
  "Softies",
  "Softseas",
  "Sole",
  "Soluble",
  "Solution",
  "Solutions",
  "Spaces",
  "Spare",
  "Special",
  "Specific",
  "Speckles",
  "Spider",
  "Spin",
  "Spinner",
  "Spiral",
  "Splitter",
  "Sport",
  "Sports",
  "Spot",
  "Spot-On",
  "Spray",
  "Sprays",
  "Sprinkle",
  "Sprinkler",
  "Squash",
  "Squeakair",
  "Squeaker",
  "Squeakers",
  "Squeezz",
  "Squiggles",
  "Stages",
  "Stain",
  "Stainless",
  "Staphylococci",
  "Star",
  "Starfish",
  "Starry",
  "Starter",
  "Steel",
  "Stellar",
  "Sterilised",
  "Stew",
  "Stick",
  "Stickaroo",
  "Sticks",
  "Stomach",
  "Stomodine",
  "Stop",
  "Storage",
  "Strategy",
  "Strength",
  "Stress",
  "Stretchezz",
  "Stripping",
  "Stroke",
  "Strong",
  "Stuff",
  "Stuff'n",
  "Styles",
  "Styptic",
  "Suit",
  "Superfood",
  "Supper",
  "Suppers",
  "Supplement",
  "Support",
  "Surosolve",
  "Sushi",
  "Suspension",
  "Swabs",
  "Swedencare",
  "Sweet",
  "Switcheroos",
  "Swizzle",
  "Synbiotic",
  "Syringe",
  "Syrup",
  "Tablets",
  "TagAlong",
  "Tagine",
  "Tangle",
  "Tape",
  "Tapewormer",
  "Tasty",
  "Teaser",
  "Teddy",
  "Teething",
  "Tennis",
  "Tennishoes",
  "Terrine",
  "Test",
  "Tests",
  "Tether",
  "The",
  "Thiafeline",
  "Thiamacare",
  "ThunderShirt",
  "Thyforon",
  "Thyroid",
  "Thyronorm",
  "Tick",
  "Tiger",
  "Tinker",
  "Tins",
  "Tone",
  "Toothbrush",
  "Toothpaste",
  "Top",
  "Toxins",
  "Toy",
  "Toys",
  "Training",
  "Transport",
  "Travel",
  "Trays",
  "Treat",
  "Treatment",
  "Treats",
  "Trial",
  "Trichogram",
  "Triple",
  "Tritrichomonas",
  "Trixie",
  "Trocoxil",
  "Tropics",
  "Tub",
  "Tube",
  "Tuck",
  "Tug",
  "TuggerKnots",
  "Tuggz",
  "Tuna",
  "Turkey",
  "Tutu",
  "Tweezerz",
  "Twists",
  "Twistz",
  "Two",
  "Tyre",
  "U/C",
  "Ultimate",
  "Ultra",
  "Undercoat",
  "Unicorn",
  "Urinalysis",
  "Urinary",
  "Urine",
  "VETERINARY",
  "Variety",
  "Veg",
  "Vegan",
  "Vegetable",
  "Vegetables",
  "Veggie",
  "VeggieDent",
  "Venison",
  "Vet",
  "Vet's",
  "VetIQ",
  "VetPen",
  "Vetbed",
  "Vetericyn",
  "Veterinary",
  "Vetoryl",
  "Vetpen",
  "Viacutan",
  "Vibez",
  "Vibrant",
  "Vidalta",
  "Virbac",
  "Virus",
  "Vis",
  "Vitality",
  "Wag",
  "Walk",
  "Walka",
  "Walking",
  "Walkrite",
  "Wally",
  "Wash",
  "Water",
  "Waterproof",
  "Wavz",
  "Wax",
  "Weaves",
  "Web",
  "Weekend",
  "Weight",
  "Wellbeloved",
  "Wet",
  "Whale",
  "Whirlwind",
  "Whistle",
  "White",
  "Wholesome",
  "Wicker",
  "Wiggi",
  "Wild",
  "Winders",
  "Window",
  "Winkz",
  "Wipes",
  "With",
  "Wobbler",
  "Wood",
  "Wooden",
  "Woodland",
  "Woofbrush",
  "Woozles",
  "Working",
  "Worm",
  "Wormer",
  "Wormscreen",
  "Wound",
  "Wounds",
  "Wrangler",
  "Wubba",
  "Yarnimals",
  "Yellow",
  "Yersinia",
  "Yorkshire",
  "Young",
  "Ypozane",
  "YuCARE",
  "YuMOVE",
  "YuMove",
  "Zazzle",
  "Zincoseb",
  "Zitac",
  "Zoom",
  "Zurich",
  "Zylkene",
  "add",
  "and",
  "b/d",
  "breed",
  "breeds",
  "c/d",
  "called",
  "cat",
  "cats",
  "chewable",
  "comprehensive",
  "d/d",
  "dogs",
  "for",
  "formerly",
  "i/d",
  "individual",
  "j/d",
  "k/d",
  "known",
  "l/d",
  "m/d",
  "makeup",
  "mg/ml",
  "microgram/ml",
  "mixed",
  "oral",
  "pack",
  "pets",
  "profile",
  "pure",
  "qPCR",
  "r/d",
  "s/d",
  "solution",
  "speciation",
  "syrup",
  "t/d",
  "tablets",
  "test",
  "the",
  "thrive",
  "u/d",
  "under",
  "w/d",
  "with",
  "y/d",
  "z/d"
];




var fuseCategorically;
var fuseTypos;

function fuseSearch(query) {
  var useQuery = query;
  let termLower = query.toLowerCase();

  // Filter out omit words (but keep original query intact)
  fuseFilterOmit.forEach(word => {
    if (termLower.includes(word) && !(word === "health" && termLower.includes("healthcare"))) {
      // Remove the word from the query
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      useQuery = useQuery.replace(regex, '').trim();
    }
  });

  // fuse match
  const categoricalResults = fuseCategorically.search(useQuery);
  if (categoricalResults.length && categoricalResults[0].score < 0.4) {
    const best = categoricalResults[0].item;
    window.location.href = best.url;
  } else {
    const wordResults = fuseTypos.search(useQuery);
    
    const words = useQuery.split(/\s+/);
    const correctedWords = [];
    let correctionMade = false;
    words.forEach(word => {
      const typoMatch = fuseTypos.search(word);
      if (typoMatch.length && typoMatch[0].score < 0.4) {
        correctedWords.push(typoMatch[0].item); // Suggested correction
        if (typoMatch[0].item.toLowerCase() !== word.toLowerCase()) {
          correctionMade = true;
        }
      } else {
        correctedWords.push(word); // Keep original
      }
    });

    const fallbackURL = `/search?type=product,collection&q=${encodeURIComponent(query)}`;
    if (correctionMade) {
      const correctedQuery = correctedWords.join(' ');
      window.location.href = `${fallbackURL}&dym=${encodeURIComponent(correctedQuery)}`;
    } else {
      window.location.href = fallbackURL;
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {

  const params = new URLSearchParams(window.location.search);
  const dym = params.get("dym");
  if (dym) {
    const el = document.querySelector(".joii-dym");
    if (el) {
      el.innerHTML = `Did you mean: <strong>${dym}</strong>?`;
      el.style.display = "block"; // In case it's hidden
      el.classList.remove('hidden');
      el.href = `/search?type=product,collection&q=${encodeURIComponent(dym)}`;
    }
  }
  
  fuseCategorically = new Fuse(fuseCategories, {
    keys: ['term'],
    includeScore: true,
    threshold: 0.4
  });
  fuseTypos = new Fuse(fuseWords, {
    includeScore: true,
    threshold: 0.4
  });
  
  const searchForms = document.querySelectorAll("form.predictive-search");

  // override search form submit
  searchForms.forEach(function (searchForm) {
    searchForm.addEventListener("submit", function (e) {
      e.preventDefault(); // Stop default form submission
  
      const query = searchForm.querySelector("input[name='q']").value.trim();
      //const query = searchInput.value.trim();
      fuseSearch(query);
    });
  });
  
});









//search drawer js
var searchTyping;

function search_drawer(section = document) {
    if (typeof joiiDesktopSearchResults !== 'undefined' && oiiDesktopSearchResults !== null) {
      var joiiDesktopSearchDrawer = joiiDesktopSearchResults.querySelector('#joiiDesktopSearchDrawer');
      if (typeof joiiDesktopSearchDrawer !== 'undefined' && joiiDesktopSearchDrawer !== null) {
        var mouseLeaveDrawer = joiiDesktopSearchDrawer.querySelector('[data-search-drawer]');
        joiiDesktopSearchDrawer.addEventListener("mouseleave", () => {
          if (!document.body.classList.contains("nav-cooldown")) {
            mouseLeaveDrawer.classList.add("hidden");
          }
        });
      }
    }


    let searchSelectors = section.querySelectorAll("[data-search-open]");
    if (searchSelectors) {
        Array.from(searchSelectors).forEach(function(searchSelector) {
            searchSelector.addEventListener("click", (e) => {
                e.preventDefault();
                var searchDrawer = document.querySelector(
                    '[data-search-drawer][data-fullwidth="true"]'
                );
                let searchParent = searchSelector.closest("[joii-data-search-parent]");
                //let searchParent = searchSelector.closest(".joiiMobileSearch");
                console.log(searchDrawer);
                console.log('search drawer ^');
                if (searchDrawer) {
                    if (searchDrawer.classList.contains("active")) {
                        searchDrawer.classList.add("hidden");
                        searchDrawer.classList.remove("active");
                        document
                            .querySelector("body")
                            .classList.remove("no-scroll", "search-drawer-open");
                        stopFocusRotation();
                        previousFocusElement.focus();
                        previousFocusElement = "";
                    } else {
                        searchDrawer.classList.add("active");
                        searchDrawer.classList.remove("hidden");
                        document
                            .querySelector("body")
                            .classList.add("no-scroll", "search-drawer-open");
                        previousFocusElement = searchSelector;
                        focusElementsRotation(searchDrawer);
                        setTimeout(() => {
                            searchDrawer.querySelector("[joii-data-search-input]").focus();
                        }, 100);
                    }
                    __searchResult(
                        (searchDrawer.querySelector("[joii-data-search-input]").value = ""),
                        searchParent
                    );
                }
            });
            searchSelector.addEventListener("keydown", (e) => {
                document.querySelector("body").classList.add("tab-focus");
            });
        });
    }
    // search input
    let searchInputElements = section.querySelectorAll("[joii-data-search-input]");
    const headerNavBlocks = document.querySelector('.header-nav-blocks');
    const desktopSearchDrawer = document.getElementById("joiiDesktopSearchDrawer");
    
    Array.from(searchInputElements).forEach(function(searchInput) {
        let searchParent;
        if (searchInput.classList.contains('joiiMobileSearch')) {
          searchParent = searchInput.closest("[joii-data-search-parent]");
          //console.log('searchparenthasmobile');
        } else {
          searchParent = desktopSearchDrawer;
          //console.log('searchparenthasdesktop');
        }
        searchInput.addEventListener("keyup", (event) => {
            event.preventDefault();
            clearTimeout(searchTyping);
            searchTyping = setTimeout(function() {
                if (searchParent) {
                    let searchTerm = searchInput.value;
                    __searchResult(searchTerm, searchParent);
                }
            }, 1000);
        });
        searchInput.addEventListener("click", (event) => {
            let searchDrawer;
            if (searchInput.classList.contains('joiiMobileSearch')) {
              searchDrawer = document.querySelector("[data-search-drawer]");
            } else {
              searchDrawer = desktopSearchDrawer.querySelector("[data-search-drawer]");
              console.log(searchDrawer);
            }
            if (searchDrawer) {
              searchDrawer.classList.remove("hidden");
            }
        });
        searchInput.addEventListener("search", (event) => {
            event.preventDefault();
            clearTimeout(searchTyping);
            if (searchParent) {
                __searchResult("", searchParent);
            }
        });
    });

    let searchInputResetBtns = section.querySelectorAll("[data-search-reset]");
    Array.from(searchInputResetBtns).forEach(function(searchInputResetBtn) {
        searchInputResetBtn.addEventListener("click", (event) => {
            event.preventDefault();
            clearTimeout(searchTyping);
            searchInputResetBtn
                .closest("form")
                .querySelector("[joii-data-search-input]").value = "";
            setTimeout(function() {
                searchInputResetBtn
                    .closest("form")
                    .querySelector("[joii-data-search-input]")
                    .focus();
                __searchResult("");
            }, 300);
        });
    });

    let searchBySpeechs = section.querySelectorAll("[data-speech-search]");
    Array.from(searchBySpeechs).forEach(function(searchBySpeech) {
        initSpeectRecognition(searchBySpeech);
    });
}

// searchResult funtion
var __searchResult = function(searchTerm, searchparent) {
    if (searchparent) {
        let resultContainer = searchparent.querySelector("[data-result-container]");
        let suggestionContainer = searchparent.querySelector(
            "[data-suggestions-container]"
        );
        if (resultContainer) {
            let searchDrawer = resultContainer.closest("[data-search-drawer]");
            let headerStyle = searchDrawer.getAttribute("data-header");
            let suggestionStatus = searchDrawer.getAttribute("data-suggestionStatus");
            if (searchTerm.replace(/\s/g, "").length > 0) {
                if (
                    headerStyle == "logo_with_search_bar" &&
                    suggestionStatus == "false"
                ) {
                    searchDrawer.classList.remove("hidden");
                }
                if (suggestionContainer) {
                    suggestionContainer.classList.add("hidden");
                }
                resultContainer.classList.remove("hidden");
                resultContainer.innerHTML = preLoadLoadGif;
                fetch(
                        mainSearchUrl +
                        "/suggest?section_id=predictive-search&q=" +
                        searchTerm +
                        "&resources[type]=" +
                        predictiveSearchTypes +
                        "&resources[limit]=10&resources[limit_scope]=each"
                    )
                    .then((response) => {
                        return response.text();
                    })
                    .then((responseText) => {
                        let resultsMarkup = new DOMParser().parseFromString(
                            responseText,
                            "text/html"
                        );
                        resultContainer.innerHTML = resultsMarkup.querySelector(
                            "#shopify-section-predictive-search"
                        ).innerHTML;
                    });
              disableNavHover();
            } else {
                if (suggestionContainer) {
                    suggestionContainer.classList.remove("hidden");
                }
                if (
                    headerStyle == "logo_with_search_bar" &&
                    suggestionStatus == "false"
                ) {
                    searchDrawer.classList.add("hidden");
                }
                resultContainer.classList.add("hidden");
                resultContainer.innerHTML = "";
            }
        }
      if (!searchparent.classList.contains('joiiMobileSearch')) {
        var joiiDesktopSearchResults = document.querySelector('#joiiDesktopSearchResults');
        if (joiiDesktopSearchResults != null) {
          var joiiDesktopSearchDrawer = joiiDesktopSearchResults.querySelector('#joiiDesktopSearchDrawer');
          //var desktopSearchDetails = joiiDesktopSearchDrawer.closest('.custom-details-disclosure');
          joiiDesktopSearchResults.classList.add('search-megamenu-block');
          //desktopSearchDetails.classList.add('open');
          //desktopSearchDetails.setAttribute('open','');
        }
      }
    }
};

function initSpeectRecognition(searchSpeech) {
    let speechRecognition = null;
    let listening = false;
    let searchInput = null;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
        "webkitSpeechRecognition" in window &&
        userAgent.indexOf("chrome") > -1 &&
        !!window.chrome &&
        userAgent.indexOf("edg/") === -1
    ) {
        searchSpeech.classList.remove("hidden");
        speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = false;
        speechRecognition.interimResults = false;
        searchInput = searchSpeech
            .closest("form")
            .querySelector("[joii-data-search-input]");
        speechRecognition.addEventListener(
            "result",
            debounce((evt) => {
                if (evt.results) {
                    const term = evt.results[0][0].transcript;
                    searchInput.value = term;
                    searchInput.focus();
                    searchInput.dispatchEvent(new Event("input"));
                    let searchparent = searchInput.closest("[joii-data-search-parent]");
                    __searchResult(term, searchparent);
                }
            }, 300)
        );

        speechRecognition.addEventListener("audiostart", () => {
            listening = true;
            searchSpeech.classList.add("active");
        });

        speechRecognition.addEventListener("audioend", () => {
            listening = false;
            searchSpeech.classList.remove("active");
        });

        searchSpeech.addEventListener("click", function(evt) {
            evt.preventDefault();
            if (listening) {
                speechRecognition.stop();
                listening = false;
            } else {
                speechRecognition.start();
                listening = true;
            }
        });

        searchSpeech.addEventListener("keydown", (evt) => {
            if (evt.code === "Space" || evt.code === "Enter") {
                evt.preventDefault();
                if (listening) {
                    speechRecognition.stop();
                } else {
                    speechRecognition.start();
                }
            }
        });
    }
}

function search_drawer_tab() {
    let elements = document.querySelectorAll(".predictive-tab-item");
    if (elements) {
        Array.from(elements).forEach(function(element) {
            setTimeout(function() {
                element.addEventListener("click", function(event) {
                    event.preventDefault();
                    if (element.classList.contains("is-selected")) return false;
                    let parent = element.closest(".shopify-section");
                    let currentActiveTab = parent.querySelector(
                        ".predictive-tab-item.is-selected"
                    );
                    let currentActiveProducts = parent.querySelector(".content_active");
                    let selectedTabProducts = parent.querySelector(
                        "." + element.dataset.filter
                    );
                    if (selectedTabProducts) {
                        if (currentActiveTab) {
                            currentActiveTab.classList.remove("is-selected");
                        }
                        if (currentActiveProducts) {
                            currentActiveProducts.classList.remove("content_active");
                            currentActiveProducts.style.display = "none";
                        }
                        element.classList.add("is-selected");
                        selectedTabProducts.classList.add("content_active");
                        selectedTabProducts.style.display = "block";
                    }
                });
            }, 400);
        });
    }
}

function disableNavHover() {
  if (!document.body.classList.contains("nav-cooldown")) {
    document.body.classList.add('nav-cooldown');
  }
}

function enableNavHover(instant = false) {
  if (instant) {
    document.body.classList.remove('nav-cooldown');
  } else {
    setTimeout(function() {
      document.body.classList.remove('nav-cooldown');
    }, 2000);
  }
}

document.addEventListener("shopify:section:load", function(event) {
  let _section = event.target;
  search_drawer(_section);
});
document.addEventListener('DOMContentLoaded', function() {
  //search_drawer();
});